<style lang="scss">
.picker-shop {
  .sp-filter-form {
    padding: 8px 8px 0px 8px;
  }
  .sp-finder-hd {
    display: none;
  }
  .disableheadselection {
    > .cell .el-checkbox__inner {
      display: none;
    }
  }
  .el-pagination {
    margin: 0;
    padding: 10px;
  }
}
</style>
<template>
  <div class="picker-shop">
    <SpFilterForm :model="formData" size="small" @onSearch="onSearch" @onReset="onSearch">
      <SpFilterFormItem prop="name">
        <el-input v-model="formData.name" placeholder="请输入团长名称" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="telephone">
        <el-input v-model="formData.telephone" placeholder="请输入手机号" />
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder
      ref="finder"
      reserve-selection
      row-key="user_id"
      :other-config="{
        'max-height': 416,
        'header-cell-class-name': cellClass
      }"
      url="/popularize/promoter/list"
      :show-pager-text="`已选中：${localSelection.length}`"
      :fixed-row-action="true"
      :setting="setting"
      :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }"
      @select="onSelect"
      @select-all="onSelectAll"
    />
  </div>
</template>

<script>
import { createSetting } from '@caohenghu/finder'
import district from '@/common/district.json'
import BasePicker from './base'
import PageMixin from '../mixins/page'
export default {
  name: 'PickerGroup',
  extends: BasePicker,
  mixins: [PageMixin],
  config: {
    title: '选择团长'
  },
  props: ['value'],
  data() {
    return {
      list: [],
      formData: {
        name: '',
        telephone: ''
      },
      district,
      regionArea: [],
      loading: false,
      multiple: this.value?.multiple ?? true,
      localSelection: []
    }
  },
  computed: {
    setting() {
      const columns = [
        { name: '团长名称', key: 'promoter_name' },
        { name: '手机号', key: 'telephone' }
      ]
      return createSetting({
        columns: columns.filter(({ visible }) => visible !== false)
      })
    }
  },
  created() {
    // this.fetch()
    this.localSelection = this.value.data || []
    this.updateVal(this.localSelection)
  },
  methods: {
    onSelectAll(selection) {
      this.list.forEach((item) => {
        const index = this.localSelection.map((item) => item.user_id ?? item).indexOf(item.user_id)
        // 如果前面的页有选中项，selection会多于一页的数据
        if (selection.length >= this.list.length) {
          // 全选中
          if (index < 0) {
            this.localSelection.push(item)
          }
        } else {
          // 全取消
          if (index >= 0) {
            this.localSelection.splice(index, 1)
          }
        }
      })
      console.log(this.localSelection)
      this.updateVal(this.localSelection)
    },
    beforeSearch(params) {
      params = {
        ...params,
        name: this.formData.name,
        telephone: this.formData.telephone
      }
      return params
    },
    afterSearch(response) {
      const { list } = response.data.data
      this.list = list
      if (this.value.data) {
        const selectRows = list.filter((item) => this.value.data.includes(item.user_id))
        const { finderTable } = this.$refs.finder.$refs
        setTimeout(() => {
          finderTable.$refs.finderTable.setSelection(selectRows)
        })
      }
    },
    onSearch() {
      this.$refs.finder.refresh(true, true)
    },
    onSelect(selection, row) {
      if (this.multiple) {
        // 如果未包含则添加到选中，否则移除
        const index = this.localSelection.map((item) => item.user_id ?? item).indexOf(row.user_id)
        if (index < 0) {
          this.localSelection.push(row)
        } else {
          this.localSelection.splice(index, 1)
        }
        this.updateVal(this.localSelection)
      } else {
        const { finderTable } = this.$refs.finder.$refs
        console.log('finderTable:', finderTable)
        finderTable.clearSelection()
        setTimeout(() => {
          finderTable.$refs.finderTable.setSelection(selection.length > 0 ? [row] : [])
          this.updateVal([row])
        })
      }
    },
    onSelectionChange(selection) {
      this.updateVal(selection)
    }
  }
}
</script>
